<template>
  <toaster :timeout="TOASTER_TIMEOUT" @close-toaster="close">
    <template v-slot:text>
      <div>
        <span>שם בעל החשבונית עודכן ל{{ name }}</span>
      </div>
    </template>
  </toaster>
</template>

<script>
import EventBus from '@/event-bus/event-bus';
import Toaster from '@/base-components/Toaster';

const TOASTER_TIMEOUT = 3000;

export default {
  name: 'InvoiceOwnerUpdatedToaster',
  components: {
    Toaster,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TOASTER_TIMEOUT,
    };
  },
  methods: {
    close() {
      EventBus.$emit('close-toaster');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
